import React from 'react';

interface TabBlockedOverlayProps {
  onClaimLeadership: () => void;
}

/**
 * Full-screen overlay shown on non-leader tabs.
 * Quiet luxury aesthetic — matches Bigwa's ErrorFallback style.
 */
export const TabBlockedOverlay: React.FC<TabBlockedOverlayProps> = ({ onClaimLeadership }) => (
  <div style={{
    position: 'fixed',
    inset: 0,
    zIndex: 99999,
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#FAFAFA',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  }}>
    <div style={{
      textAlign: 'center',
      maxWidth: '420px',
      padding: '48px 32px',
    }}>
      <div style={{
        fontSize: '14px',
        color: '#999',
        letterSpacing: '0.1em',
        textTransform: 'uppercase' as const,
        marginBottom: '16px',
      }}>
        Bigwa
      </div>

      <h2 style={{
        fontSize: '20px',
        fontWeight: 500,
        color: '#333',
        margin: '0 0 12px',
      }}>
        O Bigwa já está aberto em outra aba
      </h2>

      <p style={{
        fontSize: '14px',
        color: '#777',
        lineHeight: 1.6,
        margin: '0 0 32px',
      }}>
        Para proteger seus dados, o Bigwa funciona em uma única aba por vez.
        Volte à aba original ou clique abaixo para usar esta.
      </p>

      <button
        onClick={onClaimLeadership}
        style={{
          background: '#477B72',
          color: '#fff',
          border: 'none',
          borderRadius: '8px',
          padding: '12px 32px',
          fontSize: '14px',
          fontWeight: 500,
          cursor: 'pointer',
          transition: 'background 0.15s',
        }}
        onMouseOver={e => (e.currentTarget.style.background = '#3a6960')}
        onMouseOut={e => (e.currentTarget.style.background = '#477B72')}
      >
        Usar esta aba
      </button>
    </div>
  </div>
);
